import { render, staticRenderFns } from "./SymbolView.vue?vue&type=template&id=84f64ac0&"
import script from "./SymbolView.vue?vue&type=script&lang=js&"
export * from "./SymbolView.vue?vue&type=script&lang=js&"
import style0 from "./SymbolView.vue?vue&type=style&index=0&id=84f64ac0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports